// extracted by mini-css-extract-plugin
export default {"deleteInfoText":"_deleteInfoText--nf3yD","PermanentDelete":"_PermanentDelete--fNHuu","Delete":"_Delete--lPT0m"};